class GettextUtils {
  getTextUnitName(message, context, poPluralForm, locale) {
    let textUnitName = message;

    if (context) {
      textUnitName = textUnitName + ' --- ' + context;
    }

    if (poPluralForm !== null && poPluralForm >= 0) {
      textUnitName = textUnitName + ' _' + this.poPluralFormToCLDRForm(poPluralForm, locale);
    }

    return textUnitName;
  }

  poPluralFormToCLDRForm(poPluralForm, locale) {
    // TODO(jean) temporary maps, finish (see if possible to share with other impl). Should be replaced by ICU
    // but that's gated on ubuntu update

    const poToCldrMapByLocale = {
      'cs-CZ': {
        '0': 'one',
        '1': 'few',
        '2': 'other',
      },
      'ja-JP': {
        '0': 'other',
      },
      'ko-KR': {
        '0': 'other',
      },
      'pl-PL': {
        '0': 'one',
        '1': 'few',
        '2': 'many',
      },
      'ro-RO': {
        '0': 'one',
        '1': 'few',
        '2': 'other',
      },
      'ru-RU': {
        '0': 'one',
        '1': 'few',
        '2': 'many',
      },
      'sk-SK': {
        '0': 'one',
        '1': 'few',
        '2': 'other',
      },
      'uk-UA': {
        '0': 'one',
        '1': 'few',
        '2': 'many',
      },
      'vi-VN': {
        '0': 'other',
      },
      'id-ID': {
        '0': 'other',
      },
      'th-TH': {
        '0': 'other',
      },
      'ms-MY': {
        '0': 'other',
      },
      'zh-CN': {
        '0': 'other',
      },
      'zh-TW': {
        '0': 'other',
      },
    };

    let poToCldrMap = poToCldrMapByLocale[locale];

    if (!poToCldrMap) {
      poToCldrMap = {
        '0': 'one',
        '1': 'other',
      };
    }

    const cldrForm = poToCldrMap[poPluralForm];
    return cldrForm || 'other';
  }
}

export default new GettextUtils();
